import {AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ViewChildren} from '@angular/core';
import {FabricRepository} from '../../../../repositories/fabric.repository';
import {PatternRepository} from '../../../../repositories/pattern.repository';

@Component({
    selector: 'app-toggle-button',
    templateUrl: './toggle-button.component.html',
    styleUrls: ['./toggle-button.component.scss'],
})
export class ToggleButtonComponent {
    @Output() toggled = new EventEmitter();
}
